import React from 'react';
import { observer } from 'mobx-react';

import './styles.scss';

type PropsType = {
    children?: React.ReactNode
}

export const LayoutContentFilters = observer(({ children }: PropsType) => {
    return (
        <div className={'layout-content-filters'}>{children}</div>
    );
});
